import React from 'react'
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs"
import OffStreetMapPage from './Tabs/OffStreetMap'
import OffStreetCurrentStatusPage from './Tabs/OffStreetCurrentStatusPage'

const OffStreetPage = () => {
  return (
      <Tabs defaultValue="map" className="relative h-full w-full gap-0 bg-background">
        <TabsList className="absolute top-4 ml-82 z-50 shadow-md border border-border">
          <TabsTrigger value="map">Off Street Map</TabsTrigger>
          <TabsTrigger value="status">Current Status</TabsTrigger>
        </TabsList>

        <TabsContent value="map" className="h-full m-0 data-[state=inactive]:hidden">
          <OffStreetMapPage />
        </TabsContent>

        <TabsContent value="status" className="h-full m-0 data-[state=inactive]:hidden">
          <OffStreetCurrentStatusPage />
        </TabsContent>
      </Tabs>
  )
}

export default OffStreetPage